import React from "react";

export function CampaignRecommendations() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-medium text-gray-800">Recommendations</h2>
        <p className="text-sm text-muted-foreground">
          Campaign recommendations content will be added here.
        </p>
      </div>
    </div>
  );
}
